import { APIConfig } from 'src/config';
import { generateResourceId } from '../utils/generate-resource-id';
import { sign, decode, JWT_SECRET, JWT_EXPIRES_IN } from '../utils/jwt';
import type { User } from '../types/user';
import { wait } from '../utils/wait';
import axiosClient from '../utils/axios-client';

const users: User[] = [
  {
    id: '5e86809283e28b96d2d38537',
    avatar: '/static/user-chen_simmons.png',
    email: 'demo@devias.io',
    name: 'Chen Simmons',
    password: 'Password123!',
    organization: 'ServCare',
    scope: 'Customer-Care'
  }
];

class AuthApi {
  private userManagementApiUrl = APIConfig.userManagementApiUrl;

  async login({ email, password }): Promise<string> {
    await wait(500);

    // get user with email & password
    const options = { email, password };
    const user = await axiosClient.get('master/user/getByOptions', { params: options });

    return new Promise((resolve, reject) => {
      try {
        // Find the user

        if (!user.data) {
          reject(new Error('Please check your email and password'));
          return;
        }

        // Create the access token
        const accessToken = sign(
          { userId: user.data.id }, JWT_SECRET, { expiresIn: JWT_EXPIRES_IN }
        );

        resolve(accessToken);
      } catch (err) {
        console.error('[Auth Api]: ', err);
        reject(new Error('Internal server error'));
      }
    });
  }

  async register({ email, name, password }): Promise<string> {
    await wait(1000);

    return new Promise((resolve, reject) => {
      try {
        // Check if a user already exists
        let user = users.find((_user) => _user.email === email);

        if (user) {
          reject(new Error('User already exists'));
          return;
        }

        user = {
          id: generateResourceId(),
          avatar: null,
          email,
          name,
          password
        };

        users.push(user);

        const accessToken = sign({ userId: user.id }, JWT_SECRET, { expiresIn: JWT_EXPIRES_IN });

        resolve(accessToken);
      } catch (err) {
        console.error('[Auth Api]: ', err);
        reject(new Error('Internal server error'));
      }
    });
  }

  // validate token stored in local storage
  async me(accessToken): Promise<User> {
    // Decode access token
    const { userId } = decode(accessToken);

    // Find the user
    const user = await axiosClient.get('master/user/getByOptions', { params: { id: userId } });

    return new Promise((resolve, reject) => {
      try {
        if (!user.data) {
          reject(new Error('Invalid authorization token'));
          return;
        }

        resolve({
          id: user.data.id,
          avatar: user.data.avatar,
          email: user.data.email,
          name: user.data.name,
          organization: user.data.organization,
          scope: user.data.scope
        });
      } catch (err) {
        console.error('[Auth Api]: ', err);
        reject(new Error('Internal server error'));
      }
    });
  }

  async getTechnicianOtp(mobileNumber): Promise<{ responseData: any, statusCode: number }> {
    const mobile = encodeURIComponent(mobileNumber);
    try {
      const res = await axiosClient
        .get(`${this.userManagementApiUrl}users/technician/otp/${mobile}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const authApi = new AuthApi();
